import OfficeDetails from './officeDetailsContainer';

export default OfficeDetails;
